import React from 'react'
import { outboundLimitHint } from '../../../../shared/ticketAttachmentLimits.js'

// What a ticket reply can carry: photos plus documents such as a courier PDF.
// Mirrors the types prism-api's validateUpload accepts.
export const REPLY_ATTACHMENT_TYPES = 'image/*,.heic,.heif,application/pdf,video/*'

/**
 * The attach button and its limit hint. `photos` comes from useOutboundPhotos.
 * The deal and order popups take photos only; a ticket reply passes
 * REPLY_ATTACHMENT_TYPES with label "Attach files" and noun "files".
 */
export function OutboundPhotoPicker({ photos, label = 'Attach photos', accept = 'image/*', noun = 'photos' }) {
  return (
    <>
      <label className="btn btn-sm btn-secondary" style={{ fontSize: '0.8rem', cursor: 'pointer', margin: 0 }}>
        {label}
        <input
          type="file"
          accept={accept}
          multiple
          disabled={photos.preparing}
          style={{ display: 'none' }}
          onChange={photos.addFromInput}
        />
      </label>
      <span className="text-muted" style={{ fontSize: '0.75rem' }}>
        {photos.preparing ? `Preparing ${noun}...` : outboundLimitHint(noun)}
      </span>
    </>
  )
}

/** The refusal message and the attached files, each with a remove button. */
export function OutboundPhotoList({ photos }) {
  return (
    <>
      {photos.error && (
        <div role="alert" style={{ fontSize: '0.8rem', marginTop: 'var(--space-1)', color: 'var(--color-error)' }}>
          {photos.error}
        </div>
      )}
      {photos.files.map((file, index) => (
        <div key={`${file.name}-${index}`} style={{ fontSize: '0.8rem', marginTop: 'var(--space-1)' }}>
          {file.name}
          <button
            aria-label={`Remove ${file.name}`}
            onClick={() => photos.removeAt(index)}
            style={{ marginLeft: 6, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-error)', fontWeight: 'bold', padding: 0 }}
          >
            &times;
          </button>
        </div>
      ))}
    </>
  )
}
